{
  "pt": {
    "integration": {
      "labels": {
        "apiTokensUsedByYou": "API tokens",
        "create_failed": "Falha ao criar",
        "crm_id": "{integration_oid_type} ID em {integration_name}: {integration_oid}",
        "description": "Descrição",
        "error": "erro",
        "integration": "Integração",
        "integrationOID": "ID de integração",
        "last_sync_with": "Última sincronização com {integration_name} ({last_sync_at})",
        "status": "estatuto",
        "synced_at": "Última sincronização: ",
        "title": "As suas integrações",
        "update_failed": "falha na atualização"
      },
      "record_actions": {
        "delete": "Para que o {record_type} seja permanentemente apagado no Ziggu (e não reapareça), o {record_type} <strong>deve primeiro ser apagado no {integration_name}</strong>."
      },
      "toasts": {
        "update": "Integração actualizada"
      }
    }
  }
}
